import { LoanPayoutDetailsModel } from "./loan-payout-details.model";

export class PayoutDetailsModel {
  nucardSequenceNumber: number;
  // LoanPayoutDetails[] loanPayoutDetails
  loanPayoutDetails: LoanPayoutDetailsModel;
}
